import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';

import apiAsyncThunkCreator, { basicApiAsyncThunkCreator } from '../../../services/apiAsyncThunkCreator';
import { CORE_SERVICES, HttpMethods } from '../../../services/api';
import { showErrorMessage, showSuccessMessage } from '../../notifications';
import { ThunkAPI } from '../../rootReducer';

import { ICreditPool } from './interfaces';

export const fetchCreditPoolById:AsyncThunk<ICreditPool, string, ThunkAPI> = createAsyncThunk(
  'creditPool/getById',
  (creditPoolId, thunk) => {
    return apiAsyncThunkCreator<ICreditPool, void>({
      endpoint: `credit-pool/${creditPoolId}`,
      microservice: CORE_SERVICES.CREDITS_SERVICE,
      authenticated: true,
      method: HttpMethods.Get
    })(undefined, thunk);
  }
);

export interface IUpdateCreditPoolNamePayload {
  name: string;
  creditPoolId: string;
}

export interface IUpdateCreditPoolMembersPayload {
  userIds: string[];
  creditPoolId: string;
}
export interface IRemoveDealPayload {
  dealId: string;
}

export const updateCreditPoolNameById: AsyncThunk<Pick<ICreditPool, 'name'>, IUpdateCreditPoolNamePayload, ThunkAPI> = createAsyncThunk(
  'creditPool/updateName',
  async (data, thunk) => {
    try {
      await basicApiAsyncThunkCreator<void, IUpdateCreditPoolNamePayload>({
        endpoint: 'credit-pool/name',
        microservice: CORE_SERVICES.CREDITS_SERVICE,
        authenticated: true,
        method: HttpMethods.Put
      })(data, thunk);
      return { name: data.name };
    } catch (error) {
      thunk.dispatch(showErrorMessage('Could not update'));
      return thunk.rejectWithValue(error);
    }
  }
);

export const updateCreditPoolMembersById: AsyncThunk<void, IUpdateCreditPoolMembersPayload, ThunkAPI> = createAsyncThunk(
  'creditPool/setMembers',
  async (data, thunk) => {
    try {
      const response = await apiAsyncThunkCreator<void, IUpdateCreditPoolMembersPayload>({
        endpoint: 'credit-pool/set-members',
        microservice: CORE_SERVICES.CREDITS_SERVICE,
        authenticated: true,
        method: HttpMethods.Post
      })(data, thunk);
      return response;
    } catch (error) {
      thunk.dispatch(showErrorMessage(JSON.stringify(error)));
      return thunk.rejectWithValue(error);
    }
  }
);

export const removeDealById: AsyncThunk<void, IRemoveDealPayload, ThunkAPI> = createAsyncThunk(
  'creditPool/removeDeal',
  async (data, thunk) => {
    try {
      const response = await apiAsyncThunkCreator<void, IRemoveDealPayload>({
        endpoint: 'credit-pool/remove-deal',
        microservice: CORE_SERVICES.CREDITS_SERVICE,
        authenticated: true,
        method: HttpMethods.Post
      })(data, thunk);
      thunk.dispatch(showSuccessMessage('credits deleted successfully'));
      return response;
    } catch (error) {
      thunk.dispatch(showErrorMessage(JSON.stringify(error)));
      return thunk.rejectWithValue(error);
    }
  }
);
